var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"voucher-transfer"},[_c(_setup.Voucher,{attrs:{"fetch-legacy-conversions":_setup.fetchLegacyConversions},on:{"user-product-info":_setup.handleUserProductInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }